import { JSX } from "react";
import { AttestationType } from "./models/attestationType";
import QdpAttestationRow from "./QdpAttestationRow";

interface QdpAttestationGroupProps {
  attestation: AttestationType;
  entityXid: string;
  groupDepth: number;
  sourceId?: string;
}

export default function QdpAttestationGroup(props: QdpAttestationGroupProps): JSX.Element {

  const targetId:string = "a" + crypto.randomUUID();

  return (
    props.attestation &&
    <>
      <li className="list-group-item bordered" data-bs-toggle="collapse" data-bs-target={"#"+targetId} >
        <div className={`col-12 evidence-depth-${props.groupDepth}`}>
          <span className="expandable">{props.attestation.Name}</span>
        </div>
      </li>
      <div className="collapse" id={targetId}>
        {
          props.attestation.Attestations && props.attestation.Attestations.map((y, i) =>
            <QdpAttestationRow row={y} key={i} rowDepth={(props.groupDepth + 1).toString()} index={i} sourceId={props.sourceId} />
          )
        }
      </div>
    </>
  );
}